import { EMPTY_OBJECT } from '../../../constants/common'
import { getQaSelector } from '../../../utils/common'
import Button from '../../Button'
import Text from '../../Text'

import {
  QA_NAME_CALENDAR_GRID_BODY_MESSAGE,
  QA_NAME_CALENDAR_GRID_BODY_MESSAGE_ACTION,
} from './CalendarGridBodyMessage.constants'

import * as styles from './CalendarGridBodyMessage.module.css'

function CalendarGridBodyMessage({
  action: { callback: onClickAction, text: actionText } = EMPTY_OBJECT,
  className = styles.CalendarGridBodyMessage,
  text,
}) {
  return (
    <div
      {...getQaSelector({ value: QA_NAME_CALENDAR_GRID_BODY_MESSAGE })}
      className={className}
    >
      <Text isSecondary>{text}</Text>
      {actionText ? (
        <Button.Text
          qaName={QA_NAME_CALENDAR_GRID_BODY_MESSAGE_ACTION}
          text={actionText}
          onClick={onClickAction}
        />
      ) : null}
    </div>
  )
}

export default CalendarGridBodyMessage
